import { equals as rambdaEquals } from "rambda";

export function isEqual<T>(a: T, b: T): boolean {
  return rambdaEquals(a, b);
}
export const eq = isEqual;
